<template>
    <v-container class="pt-0">
        <v-row
            v-if="posts && posts.length > 0"
            column
            justify-center
            align-center
            :class="{ 'featured-wrapper': true, categories: true }"
        >
            <v-col
                v-for="card in featuredSubcategories"
                :key="`${card.slug[$i18n.locale].current}`"
                cols="6"
                xs="6"
                sm="4"
                md="3"
                lg="2"
                xl="2"
                :class="{
                    featured: true,
                    'col--xs': $vuetify.breakpoint.xsOnly,
                    'col--sm': $vuetify.breakpoint.smOnly,
                    'col--md': $vuetify.breakpoint.mdOnly,
                    'col--lg': $vuetify.breakpoint.lgOnly,
                    'col--xl': $vuetify.breakpoint.xlOnly,
                    'col--sm-and-down': $vuetify.breakpoint.smAndDown
                }"
            >
                <CardSingleProduct :post="card" :img-crop="setCrop()" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import postUtilities from '~/mixins/postUtilities'
import CardSingleProduct from '~/components/cards/CardSingleProduct.vue'
export default {
    name: 'FeaturedSubcategories',
    components: {
        CardSingleProduct
    },
    mixins: [postUtilities],
    methods: {}
}
</script>
